import { createSelector, createFeatureSelector, Store } from '@ngrx/store';
import { selectShared } from './shared.selectors';
import { toSignal } from '@angular/core/rxjs-interop';
import { inject } from '@angular/core';
import { AppState } from '../models';

export const selectUser = createSelector(selectShared, (state) => state.user);

export function injectUser() {
  const store = inject<Store<AppState>>(Store<AppState>);
  return toSignal(store.select(selectUser));
}
